import { ReportListQuerySortBy } from '../ReportService';
import { ReportListGroupedBy } from '../../Components/ReportList/ReportSortGroupByButton/ReportSortGroupByButtonMenu/ReportSortGroupByButtonMenu';

const CollaboratedSearchStorage = `Smartforce.CitizenContact.CollaboratedSearchConfig`;

export interface CollaboratedSearchConfigType {
  sortBy: ReportListQuerySortBy;
  groupedBy: ReportListGroupedBy;
}

export const getCollaboratedSearchConfig = (): CollaboratedSearchConfigType => {
  const storageKey = CollaboratedSearchStorage;
  return localStorage.getItem(storageKey)
    ? JSON.parse(localStorage.getItem(storageKey) as string)
    : {
        sortBy: 'newest',
        groupedBy: 'report'
      };
};

export const setCollaboratedSearchConfig = (
  filters: CollaboratedSearchConfigType
): void => {
  const storageKey = CollaboratedSearchStorage;
  localStorage.setItem(storageKey, JSON.stringify(filters));
};
